import {
  Box,
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import {
  ForwardedRef,
  forwardRef,
  useCallback,
  useImperativeHandle,
} from "react";
import { useTranslation } from "react-i18next";
import useHomeworkState from "../state/homework.state";
import { Category } from "../utils/vtt";
import CategoryForm from "./forms/CategoryForm";
import CategoryItem from "./items/CategoryItem";

export type CategoryMangerHandle = {
  onOpen: () => void;
};

const CategoryManager = (
  _: unknown,
  ref: ForwardedRef<CategoryMangerHandle>,
) => {
  const { t } = useTranslation();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { categories, removeCategory } = useHomeworkState();

  useImperativeHandle(ref, () => ({ onOpen }), [onOpen]);

  const onCategoryDelete = useCallback(
    (category: Category) => {
      removeCategory(category.uuid ?? "");
    },
    [removeCategory],
  );

  return (
    <Modal blockScrollOnMount={false} isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{t("common.labels.categories")}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Box display="flex" flexWrap="wrap" mb={6} gap={2}>
            {Object.values(categories).length ? (
              Object.values(categories).map((category) => (
                <CategoryItem
                  key={`${category.uuid}${category.name}`}
                  category={category}
                  onDelete={onCategoryDelete}
                />
              ))
            ) : (
              <Text>{t("common.labels.no_categories")}</Text>
            )}
          </Box>
          <CategoryForm />
        </ModalBody>
        <ModalFooter>
          <Button colorScheme="gray" onClick={onClose}>
            {t("common.buttons.close")}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default forwardRef(CategoryManager);
